import React from 'react';
import { clsx } from 'clsx';

export default function DieLinesOverlay({ visible, dimensions }) {
  if (!visible) return null;

  const { width, height } = dimensions;
  const spreadWidth = width * 2; // Full spread width
  
  // Standard measurements in inches
  const BLEED_INCHES = 0.125;
  const SAFETY_INCHES = 0.5;
  const GUTTER_INCHES = 0.5;
  
  // Calculate scale factor based on page width (6" x 9" US Trade)
  const STANDARD_WIDTH = 6; // inches for single page
  const scaleFactor = width / (STANDARD_WIDTH * 144); // Convert to pixels (1 inch = 144 pixels)
  
  // Convert measurements to pixels with scaling
  const bleedMargin = Math.round(BLEED_INCHES * 144 * scaleFactor);
  const safetyMargin = Math.round(SAFETY_INCHES * 144 * scaleFactor);
  const gutterWidth = Math.round(GUTTER_INCHES * 144 * scaleFactor);
  const spineWidth = Math.round(width * 0.1); // 10% of page width

  return (
    <div className="absolute inset-0 pointer-events-none" style={{ width: spreadWidth }}>
      {/* Bleed Area (Light Blue) */}
      <div 
        className="absolute border-[2px] border-sky-400/50"
        style={{
          top: bleedMargin,
          bottom: bleedMargin,
          left: bleedMargin,
          right: bleedMargin,
          width: spreadWidth - (bleedMargin * 2),
          height: height - (bleedMargin * 2)
        }}
      >
        <div className="absolute -top-6 left-0 text-xs text-sky-600 whitespace-nowrap">
          Bleed Area (0.125")
        </div>
      </div>

      {/* Safety Margin (Dark Blue) - Left Page */}
      <div 
        className="absolute border-[2px] border-blue-600/50"
        style={{
          left: safetyMargin,
          top: safetyMargin,
          width: width - (safetyMargin * 2),
          height: height - (safetyMargin * 2),
        }}
      >
        <div className="absolute -bottom-6 left-0 text-xs text-blue-700 whitespace-nowrap">
          Safety Margin (0.5")
        </div>
      </div>

      {/* Safety Margin (Dark Blue) - Right Page */}
      <div 
        className="absolute border-[2px] border-blue-600/50"
        style={{
          left: width + safetyMargin,
          top: safetyMargin,
          width: width - (safetyMargin * 2),
          height: height - (safetyMargin * 2),
        }}
      />

      {/* Spine Area (Purple) */}
      <div 
        className="absolute bg-purple-400/20 border border-purple-500"
        style={{
          left: width - spineWidth/2,
          top: 0,
          width: spineWidth,
          height: height,
        }}
      >
        <div className="absolute -top-6 -left-20 text-xs text-purple-700 whitespace-nowrap">
          Spine Area
        </div>
      </div>

      {/* Gutter Area (Green) */}
      <div 
        className={clsx(
          "absolute bg-green-400/20 border border-green-500",
          "flex items-center justify-center"
        )}
        style={{
          left: width - gutterWidth/2,
          top: 0,
          width: gutterWidth,
          height: height,
        }}
      >
        <div className="absolute -top-6 translate-x-2 left-full text-xs text-green-700 whitespace-nowrap">
          Gutter Area
        </div>
      </div>
    </div>
  );
}